export default "__VITE_ASSET__CiuBw0XG__"